module.exports = __webpack_public_path__ + "static/media/Question3.b6432a89.svg";